import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-main-pipe",
  "use": "icon-main-pipe-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-main-pipe\">\r\n  <path d=\"M2 8h12M2 6v4M14 6v4M4 8a2 2 0 1 0 4 0 2 2 0 0 0-4 0M10 8a2 2 0 1 0 4 0 2 2 0 0 0-4 0\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" fill=\"none\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol